export const mapUserToRecipient = ({firstName, lastName, email}) =>
  encodeURIComponent(`"${firstName} ${lastName}"<${email}>`);



// WEBPACK FOOTER //
// ./src/helpers/mailHelper.js